export const saleChannel = {
  JOKR: 'JOKR',
  AGORA_SHOP: 'AGORASHOP',
  MERKAO: 'MERKAO'
};
  